













































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../../RestClient";

import DateFormatter from "../../../shared/DateFormatter";
import OverlayWindow from "../../general/OverlayWindow.vue";
import Loading from "../../general/Loading.vue";

import CategoryTypeJson from "../../../shared/CategoryTypeJson";

export default Vue.extend({
  name: "RentalStartPopup",
  components: {
    OverlayWindow,
    Loading,
  },
  props: {
    isForYouth: Boolean as PropType<boolean | null>,
    restrictToTypeId: Number as PropType<number | null>,
  },
  data() {
    return {
      detailsTitle: "Willkommen",
      selectedYouth: null as boolean | null,
      selectedRestrictToTypeId: null as number | null,
      loadingGeneral: false as boolean,
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      this.selectedYouth = this.isForYouth;
      this.selectedRestrictToTypeId = this.restrictToTypeId ? this.restrictToTypeId : 4;
    },

    closeDetails() {
      if (this.selectedYouth != null) {
        this.$emit("setIsForYouth", this.selectedYouth);
      }

      this.$emit("setRestrictToTypeId", this.selectedRestrictToTypeId);

      this.$emit("closeOverlay");
    },
  },

  watch: {},

  computed: {},
});
